import { fetchAccountSummary, fetchDashboardMetrics, loadUser, loadVendors } from 'js/actions';
import PrivateRoute from 'js/components/route_utils/PrivateRoute';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_MONITOR } from 'new/constants/pathnames';
import { useDispatch } from 'react-redux';

import { ScreenComponent } from 'new/routes/RouterManager';
import Drawer from 'new/components/drawer/Drawer';
import { DataFlowStatus } from 'new/components/monitor/DataFlowStatus';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import { router } from 'new/routes/router';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import structure, { StructureGroup } from 'new/routes/structure';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { FlowRunsScreen } from 'new/components/monitor/Runs/FlowRunsScreen';
import { TMP_DISPLAY_FLOW_RUNS } from 'js/constants/config';
import { useSectionNavigation, useLastVisitedPath } from 'new/hooks/useSectionNavigation';
const SIDEBAR_GROUPS = structure.find((s) => s.name === 'Monitor').groups();

export const Monitor: ScreenComponent<any> = () => {
  const user = useCurrentUser();
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  useSectionNavigation('monitor');

  useEffect(() => {
    dispatch(loadVendors());
    dispatch(fetchAccountSummary(user.id));
    dispatch(fetchDashboardMetrics());
    dispatch(loadUser(user.id));
  }, []);

  const defaultPath = TMP_DISPLAY_FLOW_RUNS
    ? (FlowRunsScreen.screenConfig.path as string)
    : (DataFlowStatus.screenConfig.path as string);
  const lastVisitedPath = useLastVisitedPath('monitor', ROUTE_MONITOR, defaultPath);

  return (
    <Drawer content={SIDEBAR_GROUPS as StructureGroup[]}>
      <Switch>
        {router.manager.getRoutes('monitor').map((route) => (
          <PrivateRoute key={route.name} {...route} />
        ))}
        <Route path="*">
          {lastVisitedPath ? <Redirect to={lastVisitedPath} /> : <Redirect to={defaultPath} />}
        </Route>
      </Switch>
    </Drawer>
  );
};

Monitor.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_MONITOR}`,
  domain: 'main',
  screenName: 'Monitor',
  header: {
    title: 'Monitor',
  },
};
